<template>
  <div class="uploadImage__container">
    <div class="uploadImage__item" v-for="(item, index) in list" :key="index">
      <div class="uploadImage__icon">+</div>
      <input class="uploadImage__input" type="file" @change="handleChange" :multiple="multiple"/>
      <img class="uploadImage__image" :src="item"/>
    </div>
    <!--单个图片且已上传 或 多个图片-->
    <div class="uploadImage__item" v-if="(!multiple && list.length < 1) || multiple">
      <div class="uploadImage__icon">+</div>
      <input class="uploadImage__input" type="file" @change="handleChange" :multiple="multiple"/>
      <img class="uploadImage__image" :src="url" v-if="!multiple && url"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .uploadImage{
    &__container{
      display: flex;
      flex-wrap: wrap;
    }
    &__item{
      width: 100px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #e0e0e0;
      position: relative;
    }
    &__icon{
      width: 28px;
      height: 28px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border: 2px solid #e0e0e0;
      border-radius: 50%;
      font-size: 24px;
      line-height: 24px;
      color: #e0e0e0;
      text-align: center;
      box-sizing: border-box;
    }
    &__input{
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      cursor: pointer;
      opacity: 0;
    }
    &__image{
      width: 100%;
      height: 100%;
    }
    img[src=""]{
      opacity: 0;
    }
  }
</style>

<script>
// import {uploadHeadimg} from '../api/api'
import minxinUploadImage from '../mixins/uploadImage'
export default {
  mixins: [minxinUploadImage],
  props: {
    // 多个图片
    multiple: {
      type: Boolean,
      default () {
        return false
      }
    },
    // 类型
    itype: {
      type: Number,
      default () {
        return 0
      }
    },
    // 文件名
    filename: {
      type: String,
      default () {
        return ''
      }
    },
    // 单个图片
    url: {
      type: String,
      default () {
        return ''
      }
    },
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 添加了图片
    handleChange (e) {
      console.log('handleChange')

      let files = e.target.files || e.dataTransfer.files
      let fileList = Array.from(files) // 转换成文件数组
      let list = []

      // 遍历文件数组读取并上传
      fileList.forEach(item => {
        this.readFile(item).then(res => {
          list.push(res)
          if (list.length === fileList.length) {
            list.filter(item => {
              return item !== ''
            })

            if (this.multiple) { // 上传多个图片
              if (this.list.length) { // 已经上传过
                list = this.list.concat(list)
              } else { // 未上传
              }
              console.log(list, 'ddddddaa')
              this.$emit('uploadSuccess', {
                list: list
              })
            } else { // 上传单个图片
              this.$emit('update:url', list[0])
              this.$emit('uploadSuccess', {
                url: list[0]
              })
            }

            this.$notify({
              title: '成功',
              message: '上传成功',
              type: 'success'
            })
          }
        }).catch(err => {
          this.$notify({
            title: '失败',
            message: err,
            type: 'error'
          })
        })
      })
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/uploadImage.vue